<template>
  <ul class="form-item-list">
    <li><h3>부업 또는 겸업, 계절적으로 종사하는 업무가 있습니까?</h3></li>
    <li class="text-center">
      <el-checkbox
        class="round"
        label="예"
        border
        v-model="yes"
        :error="formData.answer.error"
        @change="event => updateChecked(event, 'yes')"
      />
      <el-checkbox
        class="round"
        label="아니오"
        border
        v-model="no"
        :error="formData.answer.error"
        @change="event => updateChecked(event, 'no')"
      />
    </li>
    <li v-if="yes">
      <div class="detail-form">
        <el-row>
          <element-textbox
            v-model="detail['업무명'].value"
            :error="detail['업무명'].error"
            :label="detail['업무명'].label"
            :placeholder="detail['업무명'].placeholder"
            @input="changeDetail('업무명')"
          />
        </el-row>
      </div>
    </li>
  </ul>
</template>

<script>
import { Checkbox, Row, Col, Input } from 'element-ui';

export default {
  name: 'SideJob',
  props: ['formData'],
  components: {
    [Checkbox.name]: Checkbox,
    [Row.name]: Row,
    [Col.name]: Col,
    [Input.name]: Input,
  },
  data() {
    return {
      yes: this.formData.answer.value === '예',
      no: this.formData.answer.value === '아니오',
      detail: {
        '업무명': {
          label: "업무명",
          placeholder: '부업.겸업.계절종사중인 업무명을 입력해주세요',
          value: "",
          error: "",
          validations: [
            { type: "required", message: "필수항목입니다" }
          ],
        },
      }
    }
  },
  mounted() {
    this.$emit('update', { type: '업무명', value: '' });
  },
  methods: {
    updateChecked(event, type) {
      const reverse = type === 'yes' ? 'no' : 'yes';
      this.$data[reverse] = !event;
      this.$emit('update', { type: 'answer', value: type });
    },
    changeDetail(key) {
      this.$emit('update', { type: key, value: this.detail[key].value });
    },
  }
}
</script>

<style lang="scss" scoped>
.form-item-list {
  li {
    &.text-center {
      text-align: center;
    }
    h3 {
      font-size: 18px !important;
    }
    p {
      span.blue {
        color: #174BE6;
      }
    }
    .el-checkbox {
      &.round {
        width: 40%;
        text-align: left;

        .el-checkbox__inner {
          border-radius: 50% !important;
        }
      }
    }
  }
  .detail-form {
    h3 {
      margin-bottom: 2*$unit;
    }
    .el-row {
      margin-bottom: 2*$unit;

      &.my-1 {
        margin-bottom: $unit;
      }
      .mx-0 {
        margin-left: 10px;
        margin-right: 10px;
        margin-bottom: $unit;
      }
      .el-input {
        height: 54px;
  
        .el-input__inner {
          height: 54px;
          border-radius: 0;
        }
  
        .el-input__suffix-inner {
          line-height: 54px;
          color: #000;
        }
      }

      .element-select {
        .label {
          display: none;
        }
        .body {
          margin-top: 0;
        }
      }

      .element-radio {
        display: flex;
        justify-content: space-between;

        ul {
          li {
            margin-top: 0 !important;
            padding-right: 2*$unit;

            &::before {
              width: 1.5*$unit;
              height: 1.5*$unit;
            }
            &::after {
              width: 0.8*$unit;
              transform: rotate(-45deg) translateX(0.4rem) translateY(0.2rem);
            }
          }
        }
      }
    }
  }
}
</style>